import React from 'react';

const Footer = () => (
  <footer>
    Copyright @Natasha Tatenda Chirombe
  </footer>
);

export default Footer;
